module.exports = __webpack_public_path__ + "img/储能概览.ec6682f2.png";